import i18n from '@/lang';
import moment from 'moment';
/**
 * 一天毫秒数
 */
export const ONE_DAY_SECONDS: number = 24 * 60 * 60 * 1000;

/**
 * 将传入的时间作取00：00：00取整处理
 */
export const absZeroTime = (time: number): any => {
	if (time) {
		return moment(new Date(time)).valueOf();
	}

	return Date.now();
};

/**
 * 转换时间格式 年月日时分秒(不带格式，直接返回202106101708这种格式)
 * @param time
 * @returns
 */
export const long2DateTimeStrOrigin = (time: number): any => {
	const date = new Date();
	date.setTime(time);
	const year = date.getFullYear();
	const mon = getMonth(date);
	const day = getDay(date);
	const hour = getHour(date);
	const minute = getMinute(date);
	const second = getSecond(date);

	return `${year}${mon}${day}${hour}${minute}${second}`;
};

/**
 * 将date类型的时分秒抹成 00:00:00
 * @param date
 * @returns
 */
export const zeroDateTime = (date: Date): any => {
	if (date) {
		date.setHours(0);
		date.setMinutes(0);
		date.setSeconds(0);
	}

	return date;
};

/**
 * 转换时间格式 年月日时分秒
 * @param time
 * @returns
 */
export const long2DateTimeStr = (time: number): any => {
	const date = new Date();
	date.setTime(time);
	const year = date.getFullYear();
	const mon = getMonth(date);
	const day = getDay(date);
	const hour = getHour(date);
	const minute = getMinute(date);
	const second = getSecond(date);

	return `${year}-${mon}-${day} ${hour}:${minute}:${second}`;
};

/**
 * long2DateStr
 * @param time
 * @returns
 */
export const long2DateStr = (time: number): any => {
	if (!time) {
		return '';
	}

	const date = new Date();
	date.setTime(time);
	const year = date.getFullYear();
	const mon = getMonth(date);
	const day = getDay(date);

	return `${year}-${mon}-${day}`;
};

/**
 * 国际化时间转换
 * @param time
 * @param lang
 * @returns
 */
export const long2DateStrI18n = (time: number, lang: any): any => {
	if (!time) {
		return '';
	}

	const date = new Date();
	date.setTime(time);
	const year = date.getFullYear();
	const mon = getMonth(date);
	const day = getDay(date);
	if (lang === 'en') {
		return `${day}/${mon}/${year}`;
	}

	return `${year}-${mon}-${day}`;
};

/**
 * long2 date
 * @param time
 * @returns
 */
export const long2Date = (time: number): any => {
	const date = new Date();
	date.setTime(time);

	return date;
};

/**
 * gete date
 * @param diffDaysVal
 * @returns
 */
export const getDate = (diffDaysVal: any): any => {
	const diffDays = diffDaysVal || 0;
	const date = new Date();
	const time = date.getTime() + diffDays * 24 * 3600 * 1000;
	date.setTime(time);

	return date;
};

/**
 * 获取年月
 * @param diffDays
 * @returns
 */
export const getYearMonth = (diffDaysVal: any): any => {
	const diffDays = diffDaysVal || 0;
	const date = new Date();
	const time = date.getTime() + diffDays * 24 * 3600 * 1000;
	date.setTime(time);
	const year = date.getFullYear();
	const mon = getMonth(date);

	return `${year}${mon}`;
};

/**
 * get date str
 * @param diffDays
 * @returns
 */
export const getDateStr = (diffDaysVal: any): any => {
	const diffDays = diffDaysVal || 0;
	const date = new Date();
	const time = date.getTime() + diffDays * 24 * 3600 * 1000;
	date.setTime(time);
	const year = date.getFullYear();
	const mon = getMonth(date);
	const day = getDay(date);

	return `${year}-${mon}-${day}`;
};

/**
 * 获取月份
 * @param date
 * @returns
 */
export const getMonth = (date: Date): any => {
	const month = date.getMonth() + 1;
	const monthVal: string = month >= 10 ? `${month}` : `0${month}`;

	return monthVal;
};

/**
 * 获取日期
 * @param date
 * @returns
 */
export const getDay = (date: any): any => {
	let day = date.getDate();
	day = day >= 10 ? `${day}` : `0${day}`;

	return day;
};

/**
 * 获取小时
 * @param date
 * @returns
 */
export const getHour = (date: any): any => {
	let hour = date.getHours();
	hour = hour >= 10 ? `${hour}` : `0${hour}`;

	return hour;
};

/**
 * 获取分钟
 * @param date
 * @returns
 */
export const getMinute = (date: any): any => {
	let minute = date.getMinutes();
	minute = minute >= 10 ? `${minute}` : `0${minute}`;

	return minute;
};

/**
 * 获取秒
 * @param date
 * @returns
 */
export const getSecond = (date: any): any => {
	let second = date.getSeconds();
	second = second >= 10 ? `${second}` : `0${second}`;

	return second;
};

/**
 * 审批记录耗时
 * @param createTime 创建时间
 * @param updateTime 更新时间
 * returns {Promise<unknown>}
 */
export const handleConsumeTime = (createTime: any = '', updateTime: any = ''): any => {
	if (updateTime > createTime) {
		const result = (updateTime - createTime) / 1000;
		const d = Math.floor(Math.floor(result / 3600) / 24);
		const h = Math.floor(Math.floor(result / 3600) % 24);
		const m = Math.floor(Math.floor(result / 60) % 60);
		const s = Math.floor(result % 60);
		if (d && h && m && s) {
			return `${d}天${h}时${m}分${s}秒`;
		}
	}

	return null;
};

/**
 * 延时
 * @param time
 * @returns {Promise<unknown>}
 */
export async function sleep(time: any): Promise<any> {
	return new Promise((resolve, reject) => {
		setTimeout(resolve, time);
	});
}

/**
 * 判断同一天
 *
 * @export
 * @param {number} oldDate
 * @param {number} curDate
 * @returns {boolean}
 */
export function checkSameDay(oldDate: any, curDate: any): boolean {
	const curDateCopy: any = curDate ? curDate : new Date();
	try {
		return new Date(oldDate).toDateString() === new Date(curDate).toDateString();
	} catch (e) {
		return false;
	}
}

/**
 * 计算时间差
 *
 * @export
 * @param {number} time 传入时间戳
 * @param {number} interval 用于判断的时间间隔大小(分钟)
 * @return {*}  {boolean}
 */
export function checkTimes(time: number, interval: number): boolean {
	// 获取当前时间戳
	const dateStemp = new Date().getTime();
	const result = (dateStemp - time) / 1000;
	const minute = Math.floor(result / 60);

	return minute >= interval;
}
/** 日期格式化为MMM/dd/yyyy*/
export const isoToDateStrFormat = (isoStr: any): any => {
	const lang = i18n.locale;
	const date = new Date(isoStr);
	const year = date.getFullYear();
	const mon = getMonthByLang(date);
	const day = getDay(date);

	return lang === 'en' ? `${mon}/${day}/${year}` : `${year}/${mon}/${day}`;
};

/** 日期时间格式化为MMM/dd/yyyy HH:mm:ss */
export const isoToDateTimeStrFormat = (isoStr: any): any => {
	const lang = i18n.locale;
	const date = new Date(isoStr);
	const year = date.getFullYear();
	const mon = getMonthByLang(date);
	const day = getDay(date);
	const hour = getHour(date);
	const minute = getMinute(date);
	const second = getSecond(date);

	return lang === 'en' ? `${mon}/${day}/${year} ${hour}:${minute}:${second}` : `${year}/${mon}/${day} ${hour}:${minute}:${second}`;
};

/** 日期格式化为MMM/yyyy*/
export const isoToShortDateStrFormat = (isoStr: string): any => {
	const date = new Date(isoStr);
	const year = date.getFullYear();
	const mon = getMonthByLang(date);

	return `${mon}/${year}`;
};

/** 根据语言获取月份 */
export const getMonthByLang = (date: any): any => {
	const lang = i18n.locale;
	const locales = lang === 'en' ? 'en' : 'zh-CN';
	// 海外组件只要英文
	// const locales = 'en';

	const month = date.toLocaleString(locales, { month: 'short' });
	if (locales !== 'en') {
		return getMonth(date);
	}

	return month;
};

/** 转中文大写 */
function getMonthInUpperCase(month: any): any {
	let res = '';
	switch (month) {
		case '1月':
			res = '一月';
			break;
		case '2月':
			res = '二月';
			break;
		case '3月':
			res = '三月';
			break;
		case '4月':
			res = '四月';
			break;
		case '5月':
			res = '五月';
			break;
		case '6月':
			res = '六月';
			break;
		case '7月':
			res = '七月';
			break;
		case '8月':
			res = '八月';
			break;
		case '9月':
			res = '九月';
			break;
		case '10月':
			res = '十月';
			break;
		case '11月':
			res = '十一月';
			break;
		case '12月':
			res = '十二月';
			break;
		default:
			break;
	}

	return res;
}
